import { Link } from "react-router-dom";
import { Instagram, Mail, Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{ backgroundColor: "#111827", fontFamily: "Manrope, sans-serif" }}
      className="text-white"
    >
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <img
                src="/images/logos/tagline-blanco.png"
                alt="DAC-PAC · De altas capacidades, para altas capacidades"
                className="object-contain"
                style={{ height: "44px", width: "auto" }}
              />
            </div>
            <p className="text-[#B8D9E8] text-sm leading-relaxed max-w-xs">
              Espacios diseñados para personas con alta capacidad. Donde sentirse comprendido no es la excepción, es la norma.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.instagram.com/dacpac.campamento"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="flex items-center gap-2 text-[#B8D9E8] hover:text-white transition-colors text-sm"
              >
                <Instagram size={18} />
                @dacpac.campamento
              </a>
            </div>
            <a
              href="mailto:info@dacpac.es"
              data-testid="footer-email"
              className="flex items-center gap-2 text-[#B8D9E8] hover:text-white transition-colors text-sm mt-3"
            >
              <Mail size={18} />
              info@dacpac.es
            </a>
          </div>

          {/* Experiencias */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-widest text-[#B8D9E8] mb-5">Experiencias</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/campamento-verano" className="text-white/70 hover:text-white transition-colors text-sm">
                  Campamentos de Verano
                </Link>
              </li>
              <li>
                <Link to="/campamento-verano/campamento-urbano" className="text-white/70 hover:text-white transition-colors text-sm">
                  Campamento Urbano
                </Link>
              </li>
              <li>
                <Link to="/encuentro-adultos" className="text-white/70 hover:text-white transition-colors text-sm">
                  Encuentro Adultos
                </Link>
              </li>
              <li>
                <Link to="/cursos-especializados" className="text-white/70 hover:text-white transition-colors text-sm">
                  Extraescolares
                </Link>
              </li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-widest text-[#B8D9E8] mb-5">Información</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/equipo" className="text-white/70 hover:text-white transition-colors text-sm">
                  El equipo
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-white/70 hover:text-white transition-colors text-sm">
                  Preguntas frecuentes
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-white/70 hover:text-white transition-colors text-sm">
                  Contacto
                </Link>
              </li>
              <li>
                <Link to="/preinscripcion" className="text-white/70 hover:text-white transition-colors text-sm">
                  Preinscripción
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-white/70 hover:text-white transition-colors text-sm">
                  Aviso legal
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-white/40 text-xs">
            © 2026 Campamento DAC-PAC. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-1 text-white/40 text-xs">
            Hecho con <Heart size={12} className="text-[#B8D9E8] mx-1" /> para mentes extraordinarias
          </div>
          <div className="flex gap-5">
            <Link to="/legal" className="text-white/40 hover:text-white/70 text-xs transition-colors">Privacidad</Link>
            <Link to="/legal" className="text-white/40 hover:text-white/70 text-xs transition-colors">Cookies</Link>
            <Link to="/legal" className="text-white/40 hover:text-white/70 text-xs transition-colors">Aviso Legal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
